import { FC } from 'react';
import ReactCodeInput from 'react-code-input';

import styles from './CodeInput.module.scss';

interface Props {
  name: string;
  onChange?: (value: string) => void;
  value?: string;
  length?: number;
  autoFocus?: boolean;
}

const CodeInput: FC<Props> = ({ name, length = 6, value = '', onChange, autoFocus }) => {
  return (
    <ReactCodeInput
      className={styles.wrapper}
      name={name}
      fields={length}
      type="number"
      pattern="[0-9]*"
      inputMode="numeric"
      value={value}
      onChange={onChange}
      autoFocus={autoFocus}
    />
  );
};

export default CodeInput;